import React, { Component } from "react";

import ProductsStore from '../../data/products.js';

import ProductTemplate from '../templates/ProductTemplate.jsx';
import Price from '../../components/common/InterPrice/InterPrice.jsx';

import SaleItem from '../../components/common/SaleItem/SaleItem.jsx';

import queryString from "query-string";
import { withRouter } from "react-router-dom";

class CollaboratorPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      moduleNodeLockedChecked: false,
      moduleErrorMessage: false,
    }
 
    this.handleModuleChange = this.handleModuleChange.bind(this);    

    this.product = ProductsStore.getProductByUrl('collaborator');
  }

  updateSelection() {
    let searchObj = queryString.parse(window.location.search);
    let moduleNodeLockedChecked = false;



      if (searchObj.modules) {
      let modules = searchObj.modules.split(",");
      if (modules.length) {
        moduleNodeLockedChecked = modules.includes("collaborator-five-user-one-year-fixed");
      }   
    }

    this.setState({
      moduleNodeLockedChecked: moduleNodeLockedChecked,
    }, () => this.updateCart());
  }

  componentDidMount(){
    this.updateSelection();
  }

  handleModuleChange(name, value, checked) {
    const { moduleNodeLockedChecked } = this.state;
    let cnt = 0;
    if (moduleNodeLockedChecked) cnt++;

    if (cnt === 1 && !checked) {
      this.setState({
        moduleErrorMessage: true
      });
    } 
    switch(name) {
      case 'fixed':
        this.setState({ moduleNodeLockedChecked: checked}, () => this.updateCart());
        break;                
    }
  }

  updateCart() {
    const {moduleFloatingChecked, moduleNodeLockedChecked} = this.state;

    let previewSaleItems = [];
    let saleitems = [];
    let queryParams = [];

    if (moduleNodeLockedChecked) saleitems.push(this.product.saleitems.nodeLocked[0]);

    previewSaleItems = saleitems

    if (saleitems.length > 0) {
      let Ids = [];
      saleitems.forEach(item => { 
        Ids.push(item.id);
      })
        queryParams.push("modules=" + Ids.join(","))
    }

    this.props.cartPreviewAddProducts(previewSaleItems);

    if (queryParams.length) {
      let url = window.location.pathname.replace(process.env.PUBLIC_URL, "");
      this.props.history.push(url + '?' + queryParams.join("&"));
    }
  }

  render() {
    const { moduleNodeLockedChecked } = this.state;
    

    return (
      <ProductTemplate product={this.product}>
      <div className="page-license">
        <div className={`page-license-option`}>
          <div className="page-license-option-title">Choose license:</div>

          <SaleItem name="fixed" 
            disabled={''}
            checked={moduleNodeLockedChecked}
            title={this.product.saleitems.nodeLocked[0].title}
            price={this.product.saleitems.nodeLocked[0].price}
            information={this.product.saleitems.nodeLocked[0].description}
            className="si-addon"
            ico=""
            onClick={this.handleModuleChange} />
        </div>
      </div>  
      </ProductTemplate>
    );
  }
}

export default withRouter(CollaboratorPage);
